import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchType from '../searchType/SearchType';


class SearchTypesOfCaseLookup extends Component {
  getSearchTypeRadioButtons = () => {
    return this.props.listOfSearchTypes.map(type =>
      <SearchType
        formName="caseLookup"
        key={type}
        changeSearchType={this.props.onChange}
        isSelected={this.props.selectedSearchType === type}
        name={type}
      />
    )
  }

  render() {
    return (
      <div id="court_type_wrapper" style={{ display: 'inline-block' }}>
        <div className="form-item">
          <div className="form-radios">
            {this.getSearchTypeRadioButtons()}
          </div>
        </div>
        <div className="clear"/>
      </div>
    )
  }
}

SearchTypesOfCaseLookup.propTypes = {
  selectedSearchType: PropTypes.string,
  listOfSearchTypes: PropTypes.array.isRequired,
  onChange: PropTypes.func,
};

SearchTypesOfCaseLookup.defaultProps = {
  selectedSearchType: 'Bankruptcy',
  onChange: () => {
  },
};


export default SearchTypesOfCaseLookup;



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/SearchTypesOfCaseLookup/SearchTypesOfCaseLookup.js
 **/